module.exports = __webpack_public_path__ + "static/cross-0d8d123afcbb3911f277aeb3a3e32d98.jpg";